import React from 'react';

const CheckDoubleTickIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5334 4.19986C11.2734 3.93986 10.8534 3.93986 10.5934 4.19986L6.83342 7.95986L7.77342 8.89987L11.5334 5.1332C11.7868 4.87986 11.7868 4.4532 11.5334 4.19986ZM14.3601 4.1932L7.77342 10.7799L5.45342 8.46653C5.19342 8.20653 4.77342 8.20653 4.51342 8.46653C4.25342 8.72653 4.25342 9.14653 4.51342 9.40653L7.30009 12.1932C7.56009 12.4532 7.98009 12.4532 8.24009 12.1932L15.3001 5.13986C15.5601 4.87986 15.5601 4.45986 15.3001 4.19986H15.2934C15.0401 3.9332 14.6201 3.9332 14.3601 4.1932ZM0.746758 9.4132L3.53342 12.1999C3.79342 12.4599 4.21342 12.4599 4.47342 12.1999L4.94009 11.7332L1.68676 8.46653C1.42676 8.20653 1.00676 8.20653 0.746758 8.46653C0.486758 8.72653 0.486758 9.1532 0.746758 9.4132Z"
        fill="#969696"
      />
    </svg>
  );
};

export default CheckDoubleTickIcon;
